export const AUTH_TYPES = {
  BASIC: "basic",
  SAML: "saml",
};
